import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { loadGallery } from '../../actions/gallery';
import ImageItem from './ImageItem';


const AllImages = ({
  auth,
  loadGallery,
  gallery: {images},
}) => {

  useEffect(() => {
    loadGallery();
  }, [loadGallery]);

  return (
    <div className='container'>
    <Row xs={1} md={3} className="g-4">
        {images.map(image => (
            <ImageItem key={image._id} image={image} />
        ))}
    </Row>
    </div>
  )
};

AllImages.propTypes = {
  loadGallery: propTypes.func.isRequired,
  gallery: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
  gallery: state.gallery,
});

export default connect(mapStateToProps, { loadGallery })(AllImages);